interface Props {
    /** Número de ocurrencia de la regla dentro de las que comparten nombre (1..N). */
    index: number
}

/**
 * Badge numérico que enumera reglas duplicadas (con el mismo nombre) dentro de
 * una plantilla. Estilos tomados del diseño de Figma (chip "info").
 */
export function RuleIndexBadge({ index }: Props) {
    return (
        <span className="inline-flex h-[24px] min-w-[24px] items-center justify-center gap-1 rounded-full bg-[#E6F3FF] px-[6px] py-1 text-sm font-medium leading-[18px] text-[#0084FF]">
            {index}
        </span>
    )
}
